import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { AuthRoutingModule } from './auth-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OtpLoginComponent } from './components/otp-login/otp-login.component';
import { UtilitiesModule } from '../../utilities/utilities.module';
import { OtpVerifyComponent } from './components/otp-verify/otp-verify.component';


@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    OtpLoginComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    UtilitiesModule,
    UtilitiesModule,
    OtpVerifyComponent
  ],
  exports: [LoginComponent, OtpLoginComponent],
})
export class AuthModule {}
